import { Component } from '@angular/core';
import { NavParams } from 'ionic-angular';



/**
 * Generated class for the InvoicesListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-mct-pay-verifone',
  templateUrl: 'mct-pay-verifone.html',
})
export class MctPayVerifonePage {
  state: any;
  constructor(
    public navParams: NavParams,
  ) {
    this.state = this.navParams.get('state');
  }

  ionViewWillEnter() {

  }

  ionViewWillLeave() {
  }


}



// WEBPACK FOOTER //
// ./src/pages/mct-pay/mct-pay-verifone/mct-pay-verifone.ts